import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class InsightsOverviewService {

  private _insightsFilterChanged = new Subject<{filter: string, page: number}>();

  constructor() { }

  setInsightsFilter(filter: string, page: number) {
    this._insightsFilterChanged.next({filter, page});
  }

  onInsightsFilterChanged(): Observable<{filter: string, page: number}> {
    return this._insightsFilterChanged;
  }
}
